import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Login } from './interfaces/profile.interface';
import { NavBarItem } from '../../shared/components/nav-bar/nav-bar.interface';

@Injectable({ providedIn: 'root' })
export class WordPressProfileService {
  private httpClient = inject(HttpClient);
  public baseUrl = environment.uiService.url;

  // Perfil completo guardado aquí
  private _userProfile = new BehaviorSubject<Login | null>(null);
  public userProfile$ = this._userProfile.asObservable();

  private _isPanelOpen = new BehaviorSubject<boolean>(false);
  public isPanelOpen$ = this._isPanelOpen.asObservable();

  private _perfilMenuItems = new BehaviorSubject<NavBarItem[] | null>(null);
  public perfilMenuItems$ = this._perfilMenuItems.asObservable();

  login(): Observable<Login> {
    return this.httpClient.post<Login>(`${this.baseUrl}/login`, {});
  }

  loadUserProfile(): Observable<Login> {
    return this.httpClient.post<Login>(`${this.baseUrl}/login`, {}).pipe(
      tap(profile => this._userProfile.next(profile))
    );
  }

  get userProfile(): Login | null {
    return this._userProfile.value;
  }

  setPerfilMenuItems(navBarItems: NavBarItem[]) {
    this._perfilMenuItems.next(navBarItems);
  }

  openPanel() {
    this._isPanelOpen.next(true);
  }

  closePanel() {
    this._isPanelOpen.next(false);
  }



}
